
<template>
  <a-layout-content>
    <a-table

      :columns="columns"
      :rowKey="(record) => record.id"
      :dataSource="dataSource"
      :pagination="pagination"
      :loading="loading"
      @change="handleTableChange"
      class="video-list"
      size="middle"
      bordered
      :locale="mylocale"
      :row-selection="checkable ? rowSelection : null"
    >
      <template slot="cover" slot-scope="record">
        <problem-cover-col :problem="record"></problem-cover-col>
      </template>

      <template slot="comptext" slot-scope="record">
        <h2>{{ record.title }}</h2>
        <span v-if="record.text">
          {{ record.text.substring(0, 200) }}
          <a-tooltip
            :title="record.text"
            v-if="record.text.length > 200"
            :overlayStyle="{ maxWidth: '500px' }"
          >
            <a-icon class="more-icon" type="small-dash" />
          </a-tooltip>
        </span>
      </template>

      <template slot="comptitle" slot-scope="record">
        <span v-if="record.title">
          {{ record.title.substring(0, 200) }}
          <a-tooltip
            :title="record.title"
            v-if="record.title.length > 200"
            :overlayStyle="{ maxWidth: '500px' }"
          >
            <a-icon class="more-icon" type="small-dash" />
          </a-tooltip>
        </span>
      </template>

      <template slot="type" slot-scope="record">
        <span>{{ record.isJoined ? "Qoşulma" : "Yeni müraciət" }}</span>
      </template>

      <template slot="citizenFullName" slot-scope="record">
        {{
          `${record.citizen.firstName} ${record.citizen.lastName} ${record.citizen.fatherName}`
        }}
      </template>

      <template slot="phoneNumber" slot-scope="record">
        <span v-if="record.citizen.mobilePhoneNumber">{{
          record.citizen.mobilePhoneNumber
        }}</span>
        <span v-if="record.citizen.whatsappNumber"
          >,{{ record.citizen.whatsappNumber }}</span
        >
        <span v-if="record.citizen.homePhoneNumber"
          >,{{ record.citizen.homePhoneNumber }}</span
        >
      </template>

      <template slot="address" slot-scope="record">
        <div>{{ record.executive.region.name }} {{ record.address }}</div>
      </template>

      <template slot="actions" slot-scope="record">
        <div style="display: flex; flex-direction: column; align-items: center">
          <!-- <span
            v-if="!!record.editor && canEdit"
            style="width: 100%; text-align: center"
          >
            {{ record.editor.split(" ")[0] }} {{ record.editor.split(" ")[1] }}
            <br />
            baxır
          </span> -->

          <span
            v-if="record.editor && canEdit"
            style="width: 100%; text-align: center"
          >

            <a-alert
    :message="record.editor+' baxır'"
    banner
   
  />

          </span>

          <!-- <div v-else> -->
          <a-button
            v-if="detailButton && !record.editor"
            :style="{ backgroundColor: getColor(record), border: 'none' }"
            @click="editRequest(record)"
            type="primary"
            size="small"
          >
            <a-icon :type="canEdit ? 'edit' : 'eye'" />{{
              canEdit ? "Bax" : "Ətraflı"
            }}
          </a-button>

          <a-button
            v-if="showFiles && record.filesList && record.filesList.length > 0"
            @click="showMediaFiles(record)"
            type="primary"
            size="small"
          >
            <a-icon type="eye" />Media fayllar
          </a-button>
          <a-button
            v-if="editButton"
            style="margin: 5px"
            @click="goPage(record)"
            type="primary"
            size="small"
          >
            <a-icon type="edit" />Redaktə et
          </a-button>
          <!-- </div> -->
        </div>
      </template>
    </a-table>

    <a-modal
      title="Müraciətə əlavə olunmuş fayllar"
      v-model="mediaDialogVis"
      :footer="null"
      :width="980"
      centered
    >
      <conditional-media :filesList="files"></conditional-media>
    </a-modal>
  </a-layout-content>
</template>

<script>
import { URL } from "@/utils/api";
import mixin from "@/mixins/index";
import CitizenRequestsModal from "@/components/pages/Modals/CitizenRequestModal/index";
import ProblemCoverCol from "@/components/partials/ProblemCoverCol";
import ConditionalMedia from "@/components/partials/ConditionalMedia/index";
import EventBus from "@/EventBus";
var columns = [
  {
    title: "",
    width: "15%",
    scopedSlots: { customRender: "cover" },
    align: "center",
  },

  {
    title: "Müraciətin mətni",
    key: "text",
    scopedSlots: { customRender: "comptext" },
    width: "15%",
    align: "center",
  },
  {
    title: "Müraciət edən şəxs",
    key: "citizen",
    scopedSlots: { customRender: "citizenFullName" },
    width: "20%",
  },
  {
    title: "Əlaqə nömrəsi",
    key: "phoneNumber",
    scopedSlots: { customRender: "phoneNumber" },
    width: "10%",
  },
  /*   { title: "Tipi", key: "type",scopedSlots:{customRender:'type'},width:'10%' },
   */ {
    title: "Müraciət tarixi",
    key: "date",
    sorter: true,
    defaultSortOrder: "ascend",
    dataIndex: "dateCreatedStr",
    width: "15%",
    align: "center",
  },
  {
    title: "Müraciət növü",
    key: "type",
    width: "7%",
    scopedSlots: { customRender: "type" },
    align: "center",
  },
  {
    title: "Əməliyyat",
    key: "action",
    scopedSlots: { customRender: "actions" },
    width: "10%",
  },
];

export default {
  name: "CitizenRequestsTable",
  mixins: [mixin],
  props: {
    dataSource: Array,
    loading: Boolean,
    canEdit: Boolean,
    totalCount: Number,
    url: String,
    checkable: {
      type: Boolean,
      default: false,
    },
    showFiles: {
      type: Boolean,
      default: false,
    },
    detailButton: {
      type: Boolean,
      default: true,
    },
    editButton: {
      type: Boolean,
      default: false,
    },
    selectedMenu: Object,
  },
  components: {
    "cit-request-modal": CitizenRequestsModal,
    "problem-cover-col": ProblemCoverCol,
    "conditional-media": ConditionalMedia,
  },
  data() {
    if (window.innerWidth < 1100) {
      columns = [
        {
          title: "Müraciət edən şəxs",
          key: "citizen",
          scopedSlots: { customRender: "citizenFullName" },
          width: "17%",
        },
        {
          title: "Əlaqə nömrəsi",
          key: "phoneNumber",
          scopedSlots: { customRender: "phoneNumber" },
          width: "47%",
        },

        {
          title: "",
          key: "action",
          scopedSlots: { customRender: "actions" },
          width: "5%",
        },
      ];
    }

    return {
      prefix: URL[process.env.NODE_ENV].file_url,
      columns,
      mylocale: { emptyText: "Məlumat yoxdur" },
      pagination: {
        pageSize: 10,
        current: 1,
        position: "both",
        size: "small",
        showSizeChanger: true,
        pageSizeOptions: ["10", "20", "50", "100"],
        showTotal: (total, range) =>  'Şikayət sayı  -'+this.totalCount ||'',
        locale: { items_per_page: "/ səhifə" },
      },
      modalVisible: false,
      selectedRequest: null,
      rowSelection: {
        onChange: this.onSelectChange,
      },
      files: [],
      mediaDialogVis: false,
      forEventBus: [],
    };
  },
  mounted() {
    EventBus.$on("opened", (info) => {
            this.dataSource.forEach((item, i) => {
          if(item.editorId==info.userId){
              item.editor=null;
              item.editorId=null;
              this.$set(this.dataSource, i, item);
          }
        });
      const requestIndex = this.dataSource.findIndex(
        (item) => item.id == info.requestId
      );
     
      if (requestIndex > -1) {
        const request = this.dataSource[requestIndex];
        request.editor = info.userFullName;
        request.editorId = info.userId
        this.$set(this.dataSource, requestIndex, request);
      }
    });
  },
  methods: {
    handleTableChange(pagination, filters, sorter) {
      this.pagination = pagination;
      this.$emit("change", {
        pagination: pagination,
        filters: filters,
        sorter: sorter,
      });
    },
    goPage(request) {
      this.$router.push("/citizenrequests/" + request.id).catch((err) => {
        console.log(err);
      });
    },
    getColor(request) {
      let l = this.priorityLevels.find(
        (item) => item.name === request.priorityLevel
      );
      return l ? l.color : null;
    },
    editRequest(request) {
      if (this.selectedMenu.showInNewTab)
        window.open(`${this.url}/${request.id}`);
      else {
        this.$router.push(`${this.url}/` + request.id).catch((err) => {
          console.log(err);
        });
      }
    },
    handleModalClose() {
      this.modalVisible = false;
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      console.log(this.$emit("row-selection-change", selectedRowKeys, selectedRows),'fsdafdsaf');
     /*  this.$emit("row-selection-change", selectedRowKeys, selectedRows); */
    },
    showMediaFiles(request) {
      this.files = request.filesList;
      this.mediaDialogVis = true;
    },
  },
  watch: {
    dataSource: function () {
      if (this.dataSource) {
        this.dataSource.forEach((element, index) => {
          element.no = index + 1;
        });
      }
    },

    totalCount: function (newVal) {
      this.pagination = { ...this.pagination, total: newVal };
    },
  },
};
</script>
